import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppRentalHeader from '../containers/AppRentalHeader'
import { withNamespaces } from 'react-i18next'
import { MapPin } from 'lucide-react'
import { fetchAvailability } from '../actions/qrs'
import NmStepBarRental from '../components/NmStepBarRental'

class ZoneSelectorRentalView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      zones: null,
      description: null,
      customerName: null
    }
    this.goTo = this.goTo.bind(this)
  }

  goTo(zoneNumber, descriptionZone) {
    const { id } = this.props.match.params
    const { qrMode } = this.props.location.state
    history.push('/lockerSelectorRentalView', {
      zoneSelected: zoneNumber,
      descriptionZone,
      qr: id,
      customerName: this.state.customerName,
      qrMode
    })
  }

  componentDidMount() {
    const { id } = this.props.match.params

    const navigationEntries = window.performance.getEntriesByType('navigation')
    if (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') {
      console.log('Page was reloaded')
    }

    this.props.fetchAvailability(id)
      .then(answer => {
        const answerZones = answer.response.answerZones
        if (answerZones.multipleZones) {
          this.setState({
            zones: answerZones.multipleZones,
            description: answerZones.descriptionZones,
            customerName: answerZones.customerName
          })
        } else if (answerZones.singleZone) {
          this.setState({ customerName: answerZones.customerName }, () => {
            this.goTo(answerZones.singleZone, answerZones.descriptionZones[answerZones.singleZone - 1])
          })
        }
      })
      .catch(console.error)
  }

  renderZones() {
    const { t } = this.props
    const { zones, description } = this.state

    if (!zones || !description) {
      return (
        <div className="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      )
    }

    return (
      <div className="nm-zone-grid">
        {zones.sort((a, b) => a - b).map(zone => (
          <button
            key={zone}
            className="nm-zone-card"
            onClick={() => this.goTo(zone, description[zone - 1])}
          >
            <div className="nm-zone-card-icon">
              <MapPin size={26} />
            </div>
            <span className="nm-zone-card-number">{t('ZONA ') + zone}</span>
            <span className="nm-zone-card-desc">{t(description[zone - 1])}</span>
          </button>
        ))}
      </div>
    )
  }

  render() {
    const { t } = this.props
    const { customerName } = this.state

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <NmStepBarRental step={1} />
        <div className="nm-page">
          <div className="nm-zone-header">
            <span className="nm-zone-header-badge">{t('BIENVENIDO A')}</span>
            <h1 className="nm-zone-header-name">{customerName}</h1>
            <p className="nm-zone-header-sub">{t('SELECCIONA LA ZONA DE TAQUILLAS')}</p>
          </div>

          {this.renderZones()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  availability: state.availability,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchAvailability: bindActionCreators(fetchAvailability, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ZoneSelectorRentalView))
